import React from 'react';
import { Controller, type Control, type FieldValues } from 'react-hook-form';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"

interface SelectFloatingProps {
    label: string;
    placeholder?: string;
    errorClasses?: string;
    errorMessage?: string | undefined;
    showError?: boolean;
    dataArray?: string[];
    dataArrayWithCustomVal?: [string, string][];
    id?: string;
    options?: { label: string, value: string }[];
    name: string;
    control: Control<FieldValues>;
    disabled?: boolean;
}

const SelectFloating: React.FC<SelectFloatingProps> = ({
    label,
    placeholder,
    errorClasses = "text-sm font-medium text-destructive",
    errorMessage,
    showError = false,
    dataArray,
    dataArrayWithCustomVal,
    id = "",
    options,
    name,
    control,
    disabled = false,
}) => {
    return (
        <div className="flex flex-col w-full">
            <Label className="mb-2" htmlFor={id}>{label}</Label>

            <Controller
                control={control}
                name={name}
                render={
                    ({ field }) => (
                        <div className="flex items-center gap-2">
                            <Select
                                onValueChange={field.onChange}
                                disabled={disabled}
                                {...field}
                            >
                                <SelectTrigger className="w-full mb-1 capitalize">
                                    <SelectValue placeholder={placeholder || label} />
                                </SelectTrigger>
                                <SelectContent>
                                    {dataArray?.map((val) => {
                                        return (
                                            <SelectItem key={val} value={val}>
                                                {val}
                                            </SelectItem>
                                        );
                                    })}
                                    {dataArrayWithCustomVal?.map(([name, val]) => {
                                        return (
                                            <SelectItem key={val} value={String(val)} className="capitalize">
                                                {name}
                                            </SelectItem>
                                        );
                                    })}
                                    {options?.map(({ label, value }) => (
                                        <SelectItem key={value} value={String(value)}>
                                            {label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                            <Button disabled={disabled} className=" mb-1" variant={'outline'} onClick={() => field.onChange('')}>
                                <i className="bi bi-arrow-clockwise"></i>
                            </Button>
                        </div>
                    )}
            />

            {(showError && errorMessage) && (
                <p className={errorClasses}>
                    {errorMessage}
                </p>
            )}
        </div>
    )
}

export default SelectFloating;
